const topics = [
  { title: '2026夏季娱乐圈大事件合集', count: '36篇', tag: '热门', color: 'accent' },
  { title: '明星恋情曝光实录', count: '28篇', tag: '追踪', color: 'primary' },
  { title: '综艺节目幕后猛料', count: '24篇', tag: '独家', color: 'primary' },
  { title: '网红圈年度大瓜盘点', count: '42篇', tag: '爆款', color: 'accent' },
  { title: '品牌代言人风波始末', count: '19篇', tag: '深扒', color: 'secondary' },
  { title: '影视圈资本运作揭秘', count: '15篇', tag: '深度', color: 'secondary' },
  { title: '音乐圈恩怨情仇全纪录', count: '22篇', tag: '连载', color: 'primary' },
  { title: '社交平台热搜事件汇总', count: '31篇', tag: '实时', color: 'accent' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热门专题
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            51吃瓜视频精心策划的专题内容，一站式吃瓜体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {topics.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-200/60 transition-colors cursor-pointer group"
            >
              <div className="flex items-start justify-between mb-3">
                <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${
                  item.color === 'accent'
                    ? 'bg-accent-100 text-accent-700'
                    : item.color === 'primary'
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-secondary-100 text-secondary-700'
                }`}>
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-400">{item.count}</span>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 leading-snug group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <div className="mt-3 flex items-center text-xs text-primary-500 font-medium">
                <span>浏览专题</span>
                <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}